__turbopack_context__.v({
  "body": "L6lE_a_body",
  "content": "L6lE_a_content",
  "footer": "L6lE_a_footer",
  "header": "L6lE_a_header",
  "overlay": "L6lE_a_overlay",
  "title": "L6lE_a_title",
});
